import { render } from "./QuranPageList.vue?vue&type=template&id=ee77ec6a"
import script from "./QuranPageList.vue?vue&type=script&lang=js"
export * from "./QuranPageList.vue?vue&type=script&lang=js"
script.render = render

export default script